const filterTable = ({ data = [], text = "", columns = [] }) => {
  text = text
    .normalize("NFD")
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, "");

  const newData = data.filter((item) => {
    let valueFound = false;

    for (const column of columns) {
      const keys = column.split(".");

      let value = { ...item };

      keys.forEach((key) => {
        value = value?.[key];
      });

      valueFound = value
        ? value
            .toString()
            .normalize("NFD")
            .toLowerCase()
            .replace(/[^a-z0-9_]/g, "")
            .includes(text)
        : false;

      if (valueFound) return valueFound;
    }

    return valueFound;
  });

  return newData;
};

export default filterTable;
